/* Maison Daryah — gift option, gift letter (+AED 5), free-delivery hint and gift box checks in the cart.
   The gift option is only offered for regular fabrics: gift boxes (e.g. the Bridal Box)
   already include their own gift message, so a cart with only boxes does not show it. */
(() => {
  if (window.__mdGift) return;
  window.__mdGift = true;

  const LETTER_HANDLE = 'gift-letter';
  const FREE_AT = 4;
  let cart = null;
  let busy = false;

  const css = `
  .md-cartx{display:grid;gap:.85rem;padding:1.1rem 0 1.2rem;margin-bottom:.4rem;border-bottom:1px solid #d9cfc2;font-family:Jost,system-ui,sans-serif;color:#2b211c}
  .md-cartx__ship{margin:0;font-size:.78rem;letter-spacing:.06em;text-transform:uppercase;color:#8b6f47}
  .md-cartx__ship strong{color:#2b211c;font-weight:500}
  .md-cartx__bar{height:2px;background:#e8dfd3;margin-top:.45rem}
  .md-cartx__bar span{display:block;height:100%;background:#8b6f47;transition:width .4s ease}
  .md-cartx label.md-chk{display:flex;align-items:center;gap:.6rem;font-size:.9rem;cursor:pointer;margin:0}
  .md-cartx label.md-chk input{width:1rem;height:1rem;accent-color:#2b211c;margin:0}
  .md-cartx label.md-chk em{font-style:normal;color:#8b6f47;margin-inline-start:.25rem}
  .md-cartx__gift{display:grid;gap:.75rem;padding-inline-start:1.6rem}
  .md-cartx__letter{display:grid;gap:.5rem}
  .md-cartx textarea{width:100%;min-height:6.5rem;resize:vertical;padding:.75rem .85rem;border:1px solid #c7b9a9;background:#fbf8f4;color:#2b211c;font:1rem/1.5 "Cormorant Garamond",Georgia,serif;border-radius:0;unicode-bidi:plaintext}
  .md-cartx textarea:focus{outline:none;border-color:#2b211c}
  .md-cartx__row{display:flex;justify-content:space-between;align-items:center;gap:.75rem}
  .md-cartx__row small{font-size:.72rem;color:#8b7d70}
  .md-cartx__save{background:#2b211c;color:#f6f1ea;border:0;padding:.6rem 1.1rem;font:500 .7rem Jost,sans-serif;letter-spacing:.14em;text-transform:uppercase;cursor:pointer}
  .md-cartx__save[disabled]{opacity:.5;cursor:default}
  .md-cartx__status{margin:0;font-size:.78rem;color:#8b6f47;min-height:1em}
  .md-cartx [hidden]{display:none!important}
  .md-cartx__warn{margin:0;padding:.8rem .9rem;border:1px solid #c9a99a;background:#fbf3ef;color:#7a3626;font-size:.85rem;line-height:1.5}
  .md-cartx__warn a{color:#2b211c;font-weight:500;text-decoration:underline}
  .cart__ctas.md-blocked{display:none!important}
  /* Keep the cart's remove (bin) button square: the brand button padding was squeezing its icon to 0 width */
  button.button.cart-items__remove{padding:0!important;place-items:center;min-width:var(--minimum-touch-target,44px)}
  button.button.cart-items__remove svg{width:20px;height:20px;flex:none}`;

  const style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const money = (cents) => 'Dhs. ' + (cents / 100).toFixed(2);
  const letterLine = () => cart?.items?.find((i) => i.handle === LETTER_HANDLE) || null;
  // Free delivery: automatic discounts on a subtotal of AED 500+ or 4+ pieces.
  // Most gift boxes pass the subtotal on their own; the Birthday Box (AED 220) does not.
  const FREE_SUBTOTAL = 50000;
  const isGift = () => cart?.attributes?.Gift === 'Yes' || !!letterLine();
  // Gift boxes (Bridal Box and any future "... Box" / gift products) do not get the gift option.
  const isGiftBox = (i) => i.handle === 'bridal-box' || /\b(box|gift)\b/i.test(i.product_type || '');
  const hasFabrics = () => (cart?.items || []).some((i) => i.handle !== LETTER_HANDLE && !isGiftBox(i));
  const fabricCount = () => (cart?.items || []).filter((i) => i.handle !== LETTER_HANDLE && !isGiftBox(i)).reduce((n, i) => n + i.quantity, 0);
  // Every piece counts towards "4+ pieces" (boxes too); the letter is left out to stay on the safe side.
  const pieceCount = () => (cart?.items || []).filter((i) => i.handle !== LETTER_HANDLE).reduce((n, i) => n + i.quantity, 0);
  const isBirthday = (i) => i.handle === 'birthday-box' || /birthday/i.test(i.product_type || '');
  const isBridal = (i) => /^bridal-box/.test(i.handle || '') || /bridal box/i.test(i.product_type || '');
  // Gift boxes must carry the choices made on their product page:
  // Bridal Boxes (Luxury and Classic) need 2 fabrics and a scent, Mommy & Me boxes 1 fabric,
  // the Birthday Box 1 fabric, a scent and a charm.
  const isMommy = (i) => /^mommy-me/.test(i.handle || '') || /mommy/i.test(i.product_type || '');
  const requiredFabrics = (i) => (isMommy(i) || isBirthday(i) ? 1 : isBridal(i) ? 2 : 0);
  const chosenFabrics = (i) => Object.entries(i.properties || {}).filter(([k, v]) => /^Fabric( \d+)?$/.test(k) && v).length;
  const has = (i, key) => !!(i.properties || {})[key];
  const missingChoice = (i) =>
    requiredFabrics(i) > chosenFabrics(i) ||
    ((isBridal(i) || isBirthday(i)) && !has(i, 'Perfume')) ||
    (isBirthday(i) && !has(i, 'Charm'));
  const missingLine = () => (cart?.items || []).find(missingChoice) || null;
  const boxMissingFabrics = () => !!missingLine();
  const warnHtml = () => {
    const l = missingLine();
    if (!l) return '';
    const url = esc((l.url || '/collections/gifts').split('?')[0]);
    const title = esc(l.product_title || 'gift box');
    return `<p class="md-cartx__warn" role="alert">The ${title} in your bag is missing its choices. Please remove it and add it again from the <a href="${url}">${title} page</a>.<br>يوجد بوكس بدون اختيار محتوياته. الرجاء حذفه وإضافته من جديد من <a href="${url}">صفحة البوكس</a>.</p>`;
  };
  function guardCheckout() {
    const block = boxMissingFabrics();
    document.querySelectorAll('.cart__ctas').forEach((c) => c.classList.toggle('md-blocked', block));
  }
  // Bridal and Mommy & Me boxes ship free (they pass the subtotal, or have their own free rate),
  // so a bag with only those boxes never needs the "add more" nudge. The Birthday Box pays delivery.
  const onlyFreeBoxes = () => (cart?.items || []).length > 0 && !hasFabrics() && !(cart?.items || []).some(isBirthday);
  const freeDelivery = () => (cart?.items_subtotal_price || 0) >= FREE_SUBTOTAL || pieceCount() >= FREE_AT || onlyFreeBoxes();

  async function loadCart() {
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    cart = await r.json();
    return cart;
  }

  function shipHtml() {
    const n = pieceCount();
    const free = freeDelivery();
    const left = free ? 0 : Math.max(1, FREE_AT - n);
    const pct = free ? 100 : Math.min(100, (n / FREE_AT) * 100);
    const msg = left > 0
      ? `Add ${left} more fabric${left > 1 ? 's' : ''} for <strong>free delivery</strong>`
      : `You have unlocked <strong>free delivery</strong>`;
    return `<div><p class="md-cartx__ship">${msg}</p><div class="md-cartx__bar"><span style="width:${pct}%"></span></div></div>`;
  }

  function build(box) {
    guardCheckout();
    if (!hasFabrics()) {
      box.innerHTML = warnHtml() + shipHtml();
      return;
    }
    const line = letterLine();
    const gift = isGift();
    const msg = line?.properties?.Message || box.querySelector('[data-md-text]')?.value || '';
    const showLetter = !!line || box.dataset.letterOpen === '1';
    box.innerHTML = `
      ${warnHtml()}${shipHtml()}
      <label class="md-chk"><input type="checkbox" data-md-gift ${gift ? 'checked' : ''}><span>This order is a gift</span></label>
      <div class="md-cartx__gift" ${gift ? '' : 'hidden'}>
        <label class="md-chk"><input type="checkbox" data-md-letter ${showLetter ? 'checked' : ''}><span>Add a handwritten letter<em>+ ${money(window.mdGiftLetterPrice || 500)}</em></span></label>
        <div class="md-cartx__letter" ${showLetter ? '' : 'hidden'}>
          <textarea data-md-text dir="auto" maxlength="400" placeholder="Write your message here">${esc(msg)}</textarea>
          <div class="md-cartx__row"><small data-md-count>${[...msg].length}/400</small>
            <button type="button" class="md-cartx__save" data-md-save>${line ? 'Update letter' : 'Add letter'}</button></div>
          <p class="md-cartx__status" data-md-status role="status">${line ? 'Your letter is in the bag.' : ''}</p>
        </div>
      </div>`;
  }

  function tidyLetterRows() {
    document.querySelectorAll('a[href*="/products/gift-letter"]').forEach((a) => {
      const row = a.closest('tr, li, [ref="cartItemRows[]"], .cart-items__table-row');
      row?.querySelectorAll('quantity-selector-component, cart-quantity-selector-component, .quantity-selector').forEach((q) => (q.style.visibility = 'hidden'));
    });
  }

  function mountAll() {
    tidyLetterRows();
    document.querySelectorAll('.cart__ctas').forEach((ctas) => {
      const prev = ctas.previousElementSibling;
      if (prev && prev.classList.contains('md-cartx')) return;
      const box = document.createElement('div');
      box.className = 'md-cartx';
      ctas.parentNode.insertBefore(box, ctas);
      if (cart) build(box);
    });
  }

  function refreshAll() {
    document.querySelectorAll('.md-cartx').forEach((box) => {
      if (box.contains(document.activeElement) && document.activeElement.matches('textarea')) {
        const ship = box.querySelector('.md-cartx__ship')?.parentElement;
        if (ship) ship.outerHTML = shipHtml();
        guardCheckout();
        return;
      }
      build(box);
    });
  }

  // If the fabrics are removed and only gift boxes remain, drop the gift option and any paid letter.
  async function dropGiftIfNoFabrics() {
    if (!cart || hasFabrics() || !(cart.items || []).length) return false;
    const line = letterLine();
    if (!line && cart.attributes?.Gift !== 'Yes') return false;
    busy = true;
    try {
      if (cart.attributes?.Gift === 'Yes') await post('/cart/update.js', { attributes: { Gift: '' } });
      if (line) {
        await post('/cart/change.js', { id: line.key, quantity: 0 });
        await loadCart();
        await redrawTheme('remove');
      } else {
        await loadCart();
      }
    } catch (e) {
      console.warn('[md-gift] could not remove gift option', e);
    } finally {
      busy = false;
    }
    return true;
  }

  async function sync() {
    if (busy || !document.querySelector('.cart__ctas')) return;
    await loadCart();
    await dropGiftIfNoFabrics();
    mountAll();
    refreshAll();
  }

  // Ask the theme to redraw the cart (drawer + page) after we change it.
  async function redrawTheme(action) {
    const ids = [...document.querySelectorAll('cart-items-component[data-section-id]')].map((e) => e.dataset.sectionId);
    try {
      const [{ CartLinesUpdateEvent }, sectionsRes] = await Promise.all([
        import('@shopify/events'),
        ids.length ? fetch(`${location.pathname}?sections=${[...new Set(ids)].join(',')}`).then((r) => r.json()) : Promise.resolve({}),
      ]);
      const deferred = CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(new CartLinesUpdateEvent({ action, context: 'cart', lines: [], promise: deferred.promise }));
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { sections: sectionsRes, itemCount: cart.item_count, source: 'md-gift', didError: false },
      });
    } catch (e) {
      console.warn('[md-gift] falling back to reload', e);
      location.reload();
    }
  }

  async function post(url, body) {
    const r = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    if (!r.ok) throw new Error((await r.json().catch(() => ({}))).description || 'Something went wrong');
    return r.json();
  }

  async function removeLetter() {
    const line = letterLine();
    if (!line) return;
    await post('/cart/change.js', { id: line.key, quantity: 0 });
    await loadCart();
    await redrawTheme('remove');
  }

  document.addEventListener('change', async (e) => {
    const t = e.target;
    const box = t.closest?.('.md-cartx');
    if (!box) return;
    if (t.matches('[data-md-gift]')) {
      busy = true;
      try {
        box.querySelector('.md-cartx__gift').hidden = !t.checked;
        await post('/cart/update.js', { attributes: { Gift: t.checked ? 'Yes' : '' } });
        if (!t.checked) { box.dataset.letterOpen = ''; await removeLetter(); }
        await loadCart();
      } finally { busy = false; refreshAll(); }
    }
    if (t.matches('[data-md-letter]')) {
      box.dataset.letterOpen = t.checked ? '1' : '';
      box.querySelector('.md-cartx__letter').hidden = !t.checked;
      if (t.checked) { box.querySelector('[data-md-text]')?.focus(); return; }
      busy = true;
      try { await removeLetter(); } finally { busy = false; refreshAll(); }
    }
  });

  document.addEventListener('input', (e) => {
    if (!e.target.matches?.('.md-cartx [data-md-text]')) return;
    const c = e.target.closest('.md-cartx').querySelector('[data-md-count]');
    if (c) c.textContent = `${[...e.target.value].length}/400`;
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest?.('.md-cartx [data-md-save]');
    if (!btn) return;
    const box = btn.closest('.md-cartx');
    const status = box.querySelector('[data-md-status]');
    const text = box.querySelector('[data-md-text]').value.trim();
    if (!text) { status.textContent = 'Please write your message first.'; return; }
    btn.disabled = true; status.textContent = 'Saving…'; busy = true;
    try {
      const line = letterLine();
      if (line) {
        await post('/cart/change.js', { id: line.key, quantity: 1, properties: { Message: text } });
      } else {
        await post('/cart/add.js', { items: [{ id: window.mdGiftLetterVariant, quantity: 1, properties: { Message: text } }] });
        await post('/cart/update.js', { attributes: { Gift: 'Yes' } });
      }
      await loadCart();
      box.dataset.letterOpen = '1';
      await redrawTheme(line ? 'update' : 'add');
      status.textContent = 'Your letter is in the bag.';
    } catch (err) {
      status.textContent = err.message;
    } finally {
      btn.disabled = false; busy = false;
      setTimeout(refreshAll, 400);
    }
  });

  // Keep the block in place when the theme redraws the cart.
  let t;
  new MutationObserver((records) => {
    const relevant = records.some((r) => {
      const el = r.target.nodeType === 1 ? r.target : r.target.parentElement;
      if (!el || el.closest('.md-cartx')) return false;
      return !!el.closest('cart-items-component, cart-drawer-component, .cart-drawer, .cart-page, dialog') ||
        [...r.addedNodes].some((n) => n.nodeType === 1 && (n.matches('.cart__ctas, cart-items-component') || n.querySelector?.('.cart__ctas')));
    });
    if (!relevant) return;
    clearTimeout(t);
    t = setTimeout(() => { mountAll(); sync(); }, 250);
  }).observe(document.body, { childList: true, subtree: true });

  sync();
})();
